<template>

<div class="internal">

    <div class="internal-head">

        <div class="internal-head-logo"><span>ADNAT</span></div>

        <div class="internal-head-text">

            <h1>Terms and Conditions</h1>

            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla fermentum elit at justo placerat, sit amet molestie erat volutpat. Vivamus iaculis odio nec ligula molestie faucibus. Phasellus imperdiet nisl vel erat iaculis, sit amet placerat mauris lobortis. Sed ac odio tellus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin sed tellus eget ex accumsan varius. Praesent sagittis dolor tincidunt justo imperdiet, eget dignissim mauris finibus. Maecenas ultrices ullamcorper est, ac lacinia metus euismod nec. Donec semper aliquam libero, vitae gravida velit mollis eget. Nunc eu pretium magna. In erat erat, molestie eu felis pulvinar, malesuada imperdiet orci. Aliquam a vestibulum eros. Pellentesque quis elit eu eros volutpat lobortis. Vestibulum ipsum massa, varius at tempus id, efficitur sed ex. Proin nec lorem sed magna semper ultricies non nec ex.</p>

            <p>Vivamus interdum ligula et dictum gravida. Nunc tempus auctor laoreet. Suspendisse lobortis lectus sapien, quis tempus mauris tincidunt in. Morbi lobortis, nunc ut porttitor ullamcorper, ipsum nisi malesuada libero, bibendum semper enim lacus efficitur velit. Curabitur porta tellus sit amet ex rhoncus, sed sollicitudin mauris dapibus. Vestibulum erat dolor, condimentum eget suscipit in, condimentum in ligula. Nullam molestie sodales eros, at finibus augue rhoncus nec. Curabitur nibh orci, sollicitudin et tincidunt eget, finibus nec velit. Donec sollicitudin pharetra lacus, vitae consequat mauris ultrices sed. Vestibulum maximus consectetur ipsum id ultrices. Sed pulvinar augue gravida, varius massa eget, tincidunt erat. Aliquam ut nisl eget leo maximus eleifend. Quisque et ullamcorper est. Vivamus in est ante. Nam vel pellentesque lacus. Praesent at orci scelerisque, pharetra enim at, porttitor tortor.</p>

        </div>

    </div>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.internal {
    min-height: 100vh;
}

.internal-head {
    background-color: #fff;
    background-image: url(~@/assets/home.head.png);
    background-repeat: no-repeat;
    background-position: calc(100% + 100px) -200px;
    background-size: 560px 574px;
}

.is-tablet .internal-head {
    background-position: calc(100% + 200px) -200px;
}

.is-mobile .internal-head {
    background-image: none;
}

.internal-head-logo {
    position: absolute;
    top: 36px;
    left: calc(50% - 660px);
    width: 238px;
    height: 68px;
    background-image: url(~@/assets/logo.png);
    background-size: 238px 68px;
}

.is-narrow .internal-head-logo,
.is-tablet .internal-head-logo {
    left: 20px;
}

.is-mobile .internal-head-logo {
    left: 0px;
    width: 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.internal-head-logo span {
    display: none;
}

.internal-head-text {
    max-width: 1000px;
    margin: 0px auto;
    padding: 200px 20px 40px 20px;
}

.is-mobile .internal-head-text {
    padding: 150px 20px 40px 20px;
}

.internal-head-text h1 {
    color: #425563;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 32px;
}

.is-tablet .internal-head-text h1 {
    font-size: 32px;
}

.is-mobile .internal-head-text h1 {
    font-size: 26px;
}

.internal-head-text h2 {
    color: #425563;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
}

.internal-head-text p {
    color: #707070;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
}

</style>
